import React from "react";

const Facts = ({ children }) => (
  <div
    className={
      "facts " +
      (children.length > 2 ? " gt2" : "") +
      (children.length > 3 ? " gt3" : "") +
      (children.length > 4 ? " gt4" : "") +
      (children.length > 5 ? " gt5" : "") +
      (children.length > 6 ? " gt6" : "") +
      (children.length > 7 ? " gt7" : "")
    }
  >
    {children}
  </div>
);

Facts.Fact = ({ label, value }) => (
  <div className="fact">
    <div className="fact-label">{label}</div>
    <div className="fact-value">{value}</div>
  </div>
);

export default Facts;
